import { HeatingCircuit, RadioModule, RadioSensor, WiredTemperatureSensor, } from 'z3k-config';
import { default_settings_from_sensor, } from 'console/climatic/setting-tabs/digital_sensors';
import { Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import { ClimaticDigitalSensorType } from 'console/climatic/setting-tabs/digital-sensor-type';
import { Z3KSettings, Z3KSettingsEditor } from 'z3k-settings/provider/types';
import { useContext } from 'react';
import { usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { selectDevice } from 'entities/device/lib';
export function useDigitalSensorsState() {
    const { config } = useContext(Z3KSettingsEditor);
    const { device_id } = useContext(Z3KSettings);
    const device = usePartialAppSelector(selectDevice, device_id);
    const circuit_options = HeatingCircuit.get
        .all(config)
        .filter((circuit) => circuit.type === HeatingCircuit.Type.HEATING &&
        circuit.control_devices.length > 0 &&
        HeatingCircuit.getControlModeClimatic(circuit) ===
            HeatingCircuit.ControlMode.AIR)
        .map((circuit) => ({
        circuit_id: circuit.id,
        name: circuit.name,
        air_temp_sensor: circuit.air_temp_sensor,
    }));
    const radiomodule = RadioModule.get.all(config)[0];
    const sensor_settings = ImmutableMap([
        ...WiredTemperatureSensor.get
            .all(config)
            .map((sensor) => [
            sensor.id,
            default_settings_from_sensor(sensor, ClimaticDigitalSensorType.WIRED, circuit_options),
        ]),
        ...RadioSensor.get
            .where(config, (s) => s.type != RadioSensor.Type.LEAK)
            .map((sensor) => [
            sensor.id,
            default_settings_from_sensor(sensor, ClimaticDigitalSensorType.RADIO, circuit_options),
        ]),
    ]);
    const deleted_sensor_ids = ImmutableSet();
    const online = device?.online ?? false;
    return {
        radiomodule,
        sensor_settings,
        deleted_sensor_ids,
        circuit_options,
        online,
    };
}
